import { styled, alpha } from "@mui/material";
import theme from "@styles/theme";
import { Grid } from "@mzc-pdc/ui";

export const StyledCollectionThumbnail = styled("div", {
    shouldForwardProp: (prop) => !["variant", "size"].includes(String(prop)),
})(({ theme, variant, size, selected, previewImageStyle }) => ({
    position: `relative`,
    display: `inline-flex`,
    alignItems: `center`,
    justifyContent: `center`,
    backgroundColor: selected
        ? alpha(theme.palette.greySecondary.A100, 0.4)
        : alpha(theme.palette.greySecondary[50], 0.5),
    "&:hover": {
        backgroundColor: theme.palette.greySecondary[50],
    },
    "& img": {
        ...previewImageStyle,
    },
    ".MzcCpIcon-root + * ": {
        marginLeft: 0,
    },
    ...(variant === "table" && {
        width: size === "xsmall" ? "48px" : "52px",
        height: size === "xsmall" ? "48px" : "52px",
        borderRadius: "4px",
        marginRight: `8px`,
    }),
    ...(variant === "card" && {
        minWidth: "100%",
        width: "202px",
        height: "202px",
        padding: `32px 36px 16px 12px`,
        borderRadius: "8px",
        marginRight: 0,
        "&:hover": {
            backgroundColor: theme.palette.greySecondary[50],
            ".MuiGrid-item": {
                outlineColor: theme.palette.greySecondary[50],
            },
        },
    }),
    ...(variant === "panel" && {
        minWidth: "100%",
        width: "100%",
        height: "223px",
        padding: `12px 54px 12px 24px`,
    }),
}));

export const CardThumbnail = styled(Grid)(({ previewContainerStyle }) => ({
    width: `100%`,
    height: `100%`,
    position: `relative`,
    display: `flex`,
    alignItems: `center`,
    justifyContent: `center`,
    borderRadius: 4,
    backgroundColor: alpha(theme.palette.greySecondary[100], 0.2),
}));

export const TableThumbnail = styled(Grid)(({ previewContainerStyle }) => ({
    minWidth: `100%`,
    width: `100%`,
    height: `100%`,
    position: `relative`,
    display: `flex`,
    alignItems: `center`,
    justifyContent: `center`,
    borderRadius: 4,
}));

export const ThumbnailShadow = styled("span")(({ variant }) => ({
    position: `absolute`,
    left: `100%`,
    display: `block`,
    width: variant === "table" ? 0 : 6,
    height: `-webkit-fill-available`,
    margin: variant === "table" ? `0` : variant === "panel" ? `24px 2px 0` : `10px 2px`,
    backgroundColor: alpha(theme.palette.greySecondary[100], 0.4),
    borderRadius: `0 6px 6px 0`,
    "&:before, &:after": {
        content: '""',
        display: `block`,
        position: `absolute`,
        left: `100%`,
        top: 0,
        bottom: 0,
        width: variant === "table" ? 2 : 6,
        margin: variant === "table" ? `2px 1px` : variant === "panel" ? `24px 2px 0` : `12px 2px`,
        borderRadius: `0 6px 6px 0`,
        opacity: 0.6,
        backgroundColor: theme.palette.greySecondary[100],
    },
    "&:before": {
        margin: variant === "table" ? `4px` : variant === "panel" ? `48px 10px 0` : `20px 10px`,
        opacity: 1,
    },
}));
